// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://itvruukwhgttnjpvghzq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Iml0dnJ1dWt3aGd0dG5qcHZnaHpxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTYxMjQ4MjgsImV4cCI6MjA3MTcwMDgyOH0.NWcAv2VONoAOKiXGHBMZAB42_SCPaI8nTxFTXw6GTBM";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    fetch: (url, options?: RequestInit) => {
      return fetch(url, options).then(async (response) => {
        // 🔍 Log detalhado apenas para erros 400 (Bad Request)
        if (response.status === 400) {
          const errorBody = await response.clone().text();
          console.group('❌ Supabase 400 Bad Request');
          console.error('URL:', url);
          console.error('Status:', response.status, response.statusText);
          console.error('Response:', errorBody);
          if (options?.body) {
            try {
              const bodyParsed = JSON.parse(options.body as string);
              console.error('Request Body:', bodyParsed);
            } catch {
              console.error('Request Body (raw):', options.body);
            }
          }
          console.groupEnd();
        }
        return response;
      });
    }
  }
});